import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: String,
  }

  connect() {
    this.position = 0
  }

  recalculate() {
    const newPosition = window.scrollY

    this.toggle(newPosition)

    this.position = newPosition
  }

  attributeName() {
    return `data-${this.idValue}`
  }

  toggle(newPosition) {
    if (this.scrollDirection(newPosition) === "up") {
      this.element.removeAttribute(this.attributeName())
    } else {
      this.element.setAttribute(this.attributeName(), "")
    }
  }

  // The scrollDelta could be a positive or negative number.
  // -1: scrolling down
  // +1: scrolling up
  scrollDirection(newPosition) {
    const scrollDelta = newPosition - this.position
    return scrollDelta > 0 ? "up" : "down"
  }
}
